import { z } from "zod/v4"
import { LiveIdSchema, SpaceKeySchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"

export const HomeLiveRankingCacheEntry = z.object({
  space_key: SpaceKeySchema.describe("スペースID"),
  live_id: LiveIdSchema.describe("ライブID"),
  current_count: z.number().describe("現在の同時視聴者数"),
  created_at: z.number().describe("ライブの開始日時 (UNIX Timestamp mills)"),
})

export type HomeLiveRankingCacheEntry = z.infer<typeof HomeLiveRankingCacheEntry>

export const HomeLiveRankingCacheDocumentBody = z.object({
  lives: z.array(HomeLiveRankingCacheEntry).describe("同時視聴者数降順でソート済みのライブ一覧"),
  created_at: z.number().describe("キャッシュ作成日時 (UNIX Timestamp mills)"),
  updated_at: z.number().describe("キャッシュ更新日時 (UNIX Timestamp mills)"),
})

export type HomeLiveRankingCacheDocumentBody = z.infer<typeof HomeLiveRankingCacheDocumentBody>

export type HomeLiveRankingCacheDocument = HomeLiveRankingCacheDocumentBody & {
  id: string,
}

export class HomeLiveRankingCacheDocuments {

  static readonly LATEST_DOCUMENT_ID = "latest"

  static toDocumentData(doc: HomeLiveRankingCacheDocument): object {
    return {
      ...doc,
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): HomeLiveRankingCacheDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: doc.id,
      lives: (data["lives"] ?? []).map((entry: Record<string, unknown>) => ({
        space_key: entry["space_key"],
        live_id: entry["live_id"],
        current_count: entry["current_count"],
        created_at: entry["created_at"],
      })),
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
